import * as Styled from './StyleButtonBadge'

const UnansweredBadge = () => {
  return <Styled.UnansweredButton>미답변</Styled.UnansweredButton>
}

export default UnansweredBadge
